module.exports = __webpack_public_path__ + "media/images/top/img_pickup_sendai-07f584803f8dd62881833db76bff6ca9.webp";